// [목적] 축제 status(ongoing/upcoming/unknown/ended) → 배지 라벨 / 면(面) 색 / 소형 텍스트 색 단일 정의
// [이유] 2026-09-20 디자인 QA:
//        ① 동일한 STATUS_META 가 HomePage.tsx · FestivalsPage.tsx · FestivalDetailPage.tsx 세 곳에
//           복붙돼 있었다(각 파일 주석에도 "동일 팔레트 재사용" 이라고 적혀 있으나 실제로는 복제였음).
//           라벨·색을 바꾸려면 세 곳을 동시에 고쳐야 해 드리프트 위험이 컸다.
//        ② 더 중요한 문제로, 배지 텍스트(10.5~11px)가 `color`(=brand[500]/accent[500])를 그대로 쓰고
//           있어 13% 틴트 배경 위에서 WCAG AA(4.5:1) 를 미달했다.
//             - 예정   brand[500]  on 브랜드 13% 틴트(#E2ECFC) = 3.89:1  ✗
//             - 진행 중 accent[500] on 액센트 13% 틴트(#E3F6ED) = 2.32:1  ✗✗
//           color.ts 주석이 이미 "소형 텍스트(11~14px)는 brand[600] 사용" 을 명시하고 있었는데
//           축제 배지가 그 규칙에서 빠져 있었다. 600 계열로 교체하면
//             - 예정   brand[600]  on #E2ECFC = 5.62:1  ✓
//             - 진행 중 accent[600] on #E3F6ED = 4.80:1  ✓
//             - 종료   ink.low     on #ECECEA = 4.56:1 / paper[2] = 4.74:1  ✓ (기존 유지)
// [사이드 이팩트] 세 화면의 배지 텍스트 색이 한 톤 진해진다(의도된 변경). 면·점(dot) 색은 기존 그대로라
//               전체 색 인상은 유지된다. packages/ui test/contrast.spec.ts 에 게이트 추가됨.
// [수정 시 고려사항] · 면/도트/보더에는 `color`, 텍스트에는 반드시 `textColor` 를 쓸 것.
//                   · FestivalStatus enum 확장 시 이 맵도 동시 갱신(타입이 강제).
//                   · 색만으로 상태를 전달하지 않도록 label 텍스트를 항상 함께 렌더할 것(WCAG 1.4.1).

import { tokens } from '@gangwoncanvas/ui';

import type { FestivalStatus } from '../api/festivals.client.js';

const c = tokens.color;
const L = 'light' as const;

export interface FestivalStatusMeta {
  label: string;
  /** 면·도트·보더 등 "넓은 면적" 용 색 — 기존 팔레트 유지 */
  color: string;
  /** 11px 내외 소형 배지 텍스트 전용 색 — WCAG AA 충족값 */
  textColor: string;
}

export const FESTIVAL_STATUS_META: Record<FestivalStatus, FestivalStatusMeta> = {
  ongoing: { label: '진행 중', color: c.accent[500][L], textColor: c.accent[600][L] },
  upcoming: { label: '예정', color: c.brand[500][L], textColor: c.brand[600][L] },
  unknown: { label: '일정 확인 중', color: c.warm[500][L], textColor: c.warm[600][L] },
  ended: { label: '종료', color: c.ink.low[L], textColor: c.ink.low[L] },
};
